// Этап 6, раздел 2 «Пользователи» (docs/PLAN.md) — поиск по telegram_id/username.
import { type FormEvent, useState } from "react";
import { Link } from "react-router-dom";

import { type AdminUserSummary, ApiError, searchUsers } from "../api/client";

export function UsersScreen() {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState<AdminUserSummary[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function onSubmit(event: FormEvent) {
    event.preventDefault();
    const trimmed = query.trim();
    if (!trimmed) {
      return;
    }
    setLoading(true);
    setError(null);
    try {
      setResults(await searchUsers(trimmed));
    } catch (err) {
      setResults(null);
      setError(err instanceof ApiError ? err.message : "Не удалось выполнить поиск");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="screen">
      <h2>Пользователи</h2>
      <form onSubmit={onSubmit} style={{ display: "flex", gap: 8, marginBottom: 24 }}>
        <input
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="telegram_id или @username"
          style={{ flex: 1, padding: "10px 12px", border: "1px solid var(--border)", borderRadius: 6 }}
        />
        <button type="submit" className="primary" disabled={loading}>
          {loading ? "Ищем…" : "Найти"}
        </button>
      </form>

      {error && <div className="error-text">{error}</div>}

      {results !== null && (
        <div className="card" style={{ padding: 0, overflow: "hidden" }}>
          {results.length === 0 ? (
            <div style={{ padding: 24 }}>Никого не нашли.</div>
          ) : (
            <table className="data-table">
              <thead>
                <tr>
                  <th>Telegram ID</th>
                  <th>Username</th>
                  <th>Статус</th>
                  <th>Зарегистрирован</th>
                </tr>
              </thead>
              <tbody>
                {results.map((user) => (
                  <tr key={user.id}>
                    <td>
                      <Link to={`/users/${user.id}`}>{user.telegram_id}</Link>
                    </td>
                    <td>{user.username ? `@${user.username}` : "—"}</td>
                    <td>{user.is_active ? "активен" : "заблокирован"}</td>
                    <td>{new Date(user.created_at).toLocaleDateString("ru-RU")}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
    </div>
  );
}
